<div class="flex flex-col gap-4 px-16 py-8">
  <div class="flex items-center gap-6">
    <app-button2
      appearance="secondary"
      size="s"
      [disabled]="locked()"
      [attr.title]="locked() ? (lockedReason() ?? 'Remove attached files before changing workspace') : null"
      [ariaLabel]="'Who can view this ' + itemNoun()"
      [ariaDescribedBy]="locked() ? lockedReasonId : null"
      stchPopover
      stchPopoverTrigger="click"
      [stchPopoverTemplate]="audienceMenu"
      stchPopoverPlacement="bottomLeft"
      [stchPopoverCloseOnOutsideClick]="true"
      [stchPopoverShowUntil]="closeMenu"
      [stchPopoverDisabled]="locked()"
    >
      @if (!shared()) {
        <app-icon class="mr-4" name="sapphire-lock" />
      }
      {{ controlLabel() }}
      <app-icon class="ml-4" name="sapphire-chevron-down" />
    </app-button2>
  </div>

  @if (locked()) {
    <p class="text-xs text-secondary-text" [id]="lockedReasonId">
      @if (lockedReason(); as reason) {
        {{ reason }}
      } @else {
        Workspace is locked because this {{ itemNoun() }} has attached files.
      }
    </p>
  }

  <!--
    The banner is the plain-English consequence of the control above it, so it is text rather than an
    icon-only state: a picker that says "Private to me" does not tell the user that the team cannot see
    the note, and that is the sentence Johanna's frame puts on screen.
  -->
  <p class="flex items-center gap-4 text-xs" [class.text-secondary-text]="!shared()" [class.text-warning]="shared()">
    <app-icon name="sapphire-info" size="s" />
    {{ bannerText() }}
  </p>
</div>

<ng-template #audienceMenu>
  <div class="flex flex-col py-4 min-w-110">
    <button type="button" class="flex items-center gap-6 px-12 py-6 hover:bg-hover" (click)="selectPrivate()">
      <app-icon name="sapphire-lock" />
      <span>Only me</span>
      @if (!shared()) {
        <app-icon class="ml-auto" name="sapphire-check" />
      }
    </button>

    <button type="button" class="flex items-center gap-6 px-12 py-6 hover:bg-hover" (click)="selectShared()">
      <app-icon name="sapphire-knowledge" />
      <span>{{ spaceTitle() }}</span>
      @if (shared()) {
        <app-icon class="ml-auto" name="sapphire-check" />
      }
    </button>
  </div>
</ng-template>
